import { getJson, postJson } from "utils";
import { IApiUserInfo } from "./models";

export function updateApiUser(apiUser: IApiUserInfo) {
    return postJson("/api/ApiManagement/ApiUser/UpdateApiUser", apiUser)
        .then(result => result);
}

export function generateClientSecret() {
    return getJson("/api/ApiManagement/ApiUser/GenerateClientSecret").then(result => result);
}

export function getApiUserList() {
    return postJson("/api/ApiManagement/ApiUser/UserList", null)
        .then(result => result);
}

export function checkUser(userName: string) {
    return postJson("/api/ApiManagement/ApiUser/CheckUser", userName)
        .then(result => result);
}

export function delUser(id: number) {
    return postJson("/api/ApiManagement/ApiUser/DeleteUser", id)
        .then(result => result);
}

export function getOa2TokenList(parames: any) {
    return postJson("/api/ApiManagement/Oa2Token/PageList", parames)
        .then(result => result);
}

export function checkLocation(params: any){
    return postJson("/api/ApiManagement/ApiUser/CheckLocation", params).then(result => result);
}